<template>
  <div>
    <md-card class="cardCover">

      <profile-show/>

    </md-card>
  </div>
</template>

<script>
import profileShow from "./cards/profileShow";
// import profileEdit from "./cards/profileEdit";
// import profileFollow from "./cards/profileFollow";
// import myLink from "@/components/link";

export default {
  name: "sidebarProfile",
  components: {
    profileShow,
    // profileEdit,
    // profileFollow,
    // myLink
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem('user'));
    },
    ownProfile() {
      if (this.user)
        return this.user.id === this.$route.params.id;
      if (process.env.NODE_ENV != "production")
        return true;
      throw new Error("Invalid route!")
    }
  },
};
</script>

<style scoped>
.cardCover {
  height: calc(35vh + 90px);
  margin: auto;
}

.cardFriends {
  position: relative;
  /* float: left;
  top: 16px;
  width: 25%; */
}

.buttonAdd {
  position: relative;
  display: block;
  margin: auto;
  margin-bottom: 8px;
  border-radius: 50px;
}

.dividerCard{
  margin: 0 15px;
}

.linksProfile {
  position: relative;
  margin: 0.5em auto;
  width: 90%;
}

.links {
  margin: 0 0 0 0.5em;
}
</style>
